import { styled, useTheme } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';

export const OneSourceSnackbarProvider = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();

  const styledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.success.main,
    },
    '&.notistack-MuiContent-info': {
      backgroundColor: theme.palette.info.main,
    },
  }));

  return (
    <SnackbarProvider Components={{ success: styledMaterialDesignContent, info: styledMaterialDesignContent }}>
      {children}
    </SnackbarProvider>
  );
};
